import Vue from "vue";

/**
 * Class Commission Service
 */
export default class CommissionService extends Vue {
  private customActions = {
    index: { method: 'GET', url: 'auth/commission/{platform_id}' },
    store: { method: 'POST', url: 'auth/commission/' },
    showDailyCommission: { method: 'GET', url: 'auth/user/commission/daily/{userId}{/date}' },
    showMonthlyCommission: { method: 'GET', url: 'auth/user/commission/monthly/{monthYear}/{userId}' },
    commissionList: { method: 'GET', url: 'auth/user/commission/list/{startDate}/{endDate}{/platformId}{/id_user}' },
    userTabulationsShare: { method: 'GET', url: 'auth/user/tabulations-share/{startDate}/{endDate}{/actionId}{/plugin}' },
    squadTabulationsShare: { method: 'GET', url: 'auth/squad/tabulations-share/{startDate}/{endDate}{/actionId}{/plugin}' },
    commissionStatement: { method: 'GET', url: 'auth/user/commission/statement' }
  };
  private resource: any = this.$resource(
    '',
    {},
    this.customActions
  );

  public async showDailyCommission(userId: number, date?:string ) {
    return await this.resource.showDailyCommission({ userId, date }).then(
      (response: any) => {
        return response.json();
      },
      (response: any) => {
        return response.json();
      }
    );
  }

  public showMonthlyCommission(monthYear: string, userId: number) {
    return this.resource.showMonthlyCommission({ monthYear, userId }).then(
      (response: any) => {
        return response.json();
      },
      (response: any) => {
        return response.json();
      }
    );
  }

  // GET List
  public commissionList(startDate: String, endDate: string) {
      let params: any = { startDate, endDate };
      params.platformId = this.$auth.user().id_platform;
      params.id_user = this.$auth.user().id_user;

    return this.resource.commissionList(params).then((response: any) => {
      return response.json();
    }, (response: any) => {
      return response.json();
    });
  }

  // GET tabulations share user
  public userTabulationsShare(startDate: String, endDate: string, showFunnel:boolean, action?: Array<number>, plugin?: string) {
    let params: any = { startDate, endDate }
    if (action) params.actionId = action;
    if (plugin) params.plugin = plugin;

    if (showFunnel != null || showFunnel != undefined)
      params.showFunnel = showFunnel ? 'true' : 'false';

    return this.resource.userTabulationsShare(params).then((response: any) => {
      return response.json();
    }, (response: any) => {
      return response.json();
    });
  }

  // GET tabulations share squad
  public squadTabulationsShare(startDate: String, endDate: string, showFunnel:boolean, action?: Array<number>, plugin?: string) {
    let params: any = { startDate, endDate }
    if (action) params.actionId = action;
    if (plugin) params.plugin = plugin;

    if (showFunnel != null || showFunnel != undefined)
      params.showFunnel = showFunnel ? 'true' : 'false';

    return this.resource.squadTabulationsShare(params).then((response: any) => {
      return response.json();
    }, (response: any) => {
      return response.json();
    });
  }

  public commissionStatement(data: {id_platform: string, filter?: { startDate?: string, endDate?: string }}) {
    return this.resource.commissionStatement(data).then(
      (response: any) => {
        return response.json();
      },
      (response: any) => {
        return response.json();
      }
    );
  }
    
   public index(id_platform: string ) {
       return this.resource.index({ id_platform }).then(
       (response: any) => {
        return response.json();
      },
      (response: any) => {
        return response.json();
      }
    );
   }
    
    public store(params: any) {
        return this.resource.store(params).then((response: any) => {
            return response.json();
        }, (response: any) => {
            return response.json();
        });
    }
}
